module.exports = __webpack_public_path__ + "img/thank-you-footer.85b73369.svg";